import React from 'react';
import cn from 'classnames';
import HeaderLinkItem from '@/creditflowresearch/ui/common/components/organisms/SearchResultsMenu/HeaderLinkItem';
import getSearchResultItemUrl from '@/creditflowresearch/ui/common/components/organisms/SearchResultsMenu/helpers/getSearchResultsItemUrl';
import headerStyles from '@/creditflowresearch/ui/common/components/header/Header/header.module.scss';
import styles from './resultsColumn.module.scss';

interface IProps {
  title: string,
  isBeta?: boolean,
  data: any[],
  hideOnNoResults?: boolean,
  onClick: () => void,
  activeItemName?: string,
  regionAbbreviation?: string,
  productAbbreviation?: string,
  variant?: 'default' | 'creditflow',
}

const ResultsItem = React.memo(({
  activeItemName = '',
  regionAbbreviation = '',
  productAbbreviation = '',
  variant,
  ...props
}: IProps) => {
  const hasResults = !!props.data.length;

  if (props.hideOnNoResults && !hasResults) {
    return null;
  }

  return (
    <div className={ styles.resultsBlock }>
      <div className={ cn(styles.title, {
        [styles.creditflowVariant]: variant === 'creditflow',
      }) }
      >
        { props.title && props.title }
        { props.isBeta && (
          <span className={ headerStyles.beta }>(Beta)</span>
        ) }
      </div>
      { hasResults
        ? props.data.map((item) => {
          const itemUrl = item.url || '';
          const currentItemName = item.name + itemUrl + productAbbreviation + regionAbbreviation;
          return (
            <HeaderLinkItem
              linkTo={ getSearchResultItemUrl(item) }
              isActive={ activeItemName === currentItemName }
              activeClassName={ styles.activeResultItem }
              className={ styles.resultsItem }
              onClick={ props.onClick }
              key={ currentItemName }
            >
              { item.name }
            </HeaderLinkItem>
          );
        })
        : (
          <div className={ styles.noResultsBlock }>
            No results for this region
          </div>
        ) }
    </div>
  );
});

export default ResultsItem;
